import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09ec1f0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "category-item mb-2"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-8" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "col-auto"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseDeleteButton = _resolveComponent("BaseDeleteButton")!

  return (_ctx.categoryPath)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryTree, (category, i) => {
              return (_openBlock(), _createElementBlock("p", {
                key: category,
                class: "tree-item mb-0",
                style: _normalizeStyle('margin-left:' + i +'rem')
              }, [
                (i !== 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, "- "))
                  : _createCommentVNode("", true),
                _createTextVNode(_toDisplayString(category), 1)
              ], 4))
            }), 128))
          ]),
          (!_ctx.readonly)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_BaseDeleteButton, {
                  deleteData: _ctx.removeDpCat,
                  pageUI: _ctx.pageUI,
                  itemKey: _ctx.categoryCode,
                  class: "btn-small"
                }, null, 8, ["deleteData", "pageUI", "itemKey"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}